import React, { useContext, useEffect, useState } from 'react'
import styles from '../Bookings/BookingDetails.module.css'
import { useParams } from 'react-router';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../store/auth-context';
import { MdMale } from 'react-icons/md';
import { BsGenderMale, BsPrinter } from 'react-icons/bs';
import { FaFemale, FaMale } from 'react-icons/fa';
import { FiMoreHorizontal } from 'react-icons/fi';
import ServicesListAtBD from '../../Components/Bookings/ServicesListAtBD';
import BookingActions from '../../Components/Bookings/BookingActions';
import { Link } from 'react-router-dom'
import Clock from '../../Helper/Clock.js';
import { ToastContainer } from 'react-toastify';

const BookingDetails = () => {
    const params = useParams();
    const bookingIdentifier = params.bookingIdentifier;
    const authCtx = useContext(AuthContext)
    const [bookingDetails, setBookingDetails] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [activeTab, setActiveTab] = useState('Services') // Payment Details
    const [timeLapsed, setTimeLapsed] = useState([{
        "days": 0,
        "hours": 0,
        "minutes": 0,
        "seconds": 0
    }]);
    const [isBookingOptionsOpen, setIsBookingOptionsOpen] = useState(false)
    const toggleBookingOptions = () => setIsBookingOptionsOpen(false)

    const getBookingDetails = async () => {
        setIsLoading(true)
        const getBookingDetailsResponse = await fetch(BASE_URL_API + "getBookingDetails",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    bookingIdentifier: bookingIdentifier
                })
            });

        if (!getBookingDetailsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getBookingDetailsRespo = await getBookingDetailsResponse.json();
            if (getBookingDetailsRespo.status === "success") {
                setBookingDetails(getBookingDetailsRespo.response)
            } else {
                if (getBookingDetailsRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else {

                }
            }
            console.log(getBookingDetailsRespo)
        }
        setIsLoading(false)
    }

    const timeLapsedClock = (k) => {
        const startingTime = new Date(k);

        if (!startingTime || isNaN(startingTime)) {
            console.log("Invalid starting time.");
            return;
        }

        let timerId = setInterval(() => {
            const currentTime = new Date();
            const timeLapsed = currentTime - startingTime;

            if (isNaN(timeLapsed)) {
                console.log("Error: Invalid time calculation.");
                clearInterval(timerId);
                return;
            }

            const seconds = Math.floor((timeLapsed / 1000) % 60);
            const minutes = Math.floor((timeLapsed / (1000 * 60)) % 60);
            const hours = Math.floor((timeLapsed / (1000 * 60 * 60)) % 24);
            const days = Math.floor(timeLapsed / (1000 * 60 * 60 * 24));

            // const timeLapsedString = `${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds`;
            const timeLapsedString = [{
                "days": days,
                "hours": hours,
                "minutes": minutes,
                "seconds": seconds
            }];
            setTimeLapsed(timeLapsedString)
            //   console.log(`${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds have elapsed since ${startingTime}.`);
            // return `${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds have elapsed since ${startingTime}.`;
        }, 1000);
    }

    useEffect(() => {
        getBookingDetails()
    }, [bookingIdentifier])

    useEffect(() => {
        if (bookingDetails.createdOn) {
            timeLapsedClock(bookingDetails.createdOn)
        }
    }, [bookingDetails])


    const [orgPriceTotal, setOrgPriceTotal] = useState(0)
    const [disPriceTotal, setDisPriceTotal] = useState(0)

    const calculateSum = () => {
        let tOrgPrice = 0;
        let tDisPrice = 0;
        bookingDetails?.services?.map((item, index) => {
            tOrgPrice = parseFloat(tOrgPrice) + parseFloat(parseFloat(item.totalBasePrice) * parseFloat(item.quantity));
            tDisPrice = parseFloat(tDisPrice) + parseFloat(parseFloat(item.totalDiscPrice) * parseFloat(item.quantity));
        })
        setOrgPriceTotal(tOrgPrice)
        setDisPriceTotal(tDisPrice)
    }

    useEffect(() => {
        if (bookingDetails.services !== null) {
            calculateSum()
        }
    }, [bookingDetails])


    return (
        <div className={styles.mainWrapper}>
            {isBookingOptionsOpen &&
                <BookingActions
                    isOpen={isBookingOptionsOpen}
                    toggleBookingOptions={toggleBookingOptions}
                    bookingIdentifier={bookingIdentifier}
                    bookingDetails={bookingDetails}
                />
            }
            <ToastContainer />
            <div className={styles.mainContainer}>
                <div className={styles.mainHeader}>
                    <div className={styles.navigationBtn}>
                        <div className={styles.leftCol}>
                            <div className={styles.bookingDetails}>
                                Booking ID : #{bookingDetails?.ID}
                            </div>
                        </div>
                        <div className={styles.rightCol}>
                            {/* <Link to="/bookings" className={styles.activeBookings}>10+ active bookings</Link> */}
                            <Link title="Print Invoice" to={`/invoice/${bookingDetails?.invoiceKey}`} className={styles.moreBtn} >
                                <BsPrinter />
                            </Link>
                            <div className={styles.moreBtn} onClick={() => setIsBookingOptionsOpen(true)} >
                                <FiMoreHorizontal />
                            </div>
                        </div>
                    </div>
                    <div className={styles.bookingSummary}>
                        <div>
                            <div>
                                <Link to={`/user/${bookingDetails?.clientStoreRelationIdentifier}`} className={styles.clientName}>
                                    {bookingDetails.client_name}
                                </Link>
                                <div className={styles.gender}>
                                    {bookingDetails.gender}
                                </div>
                            </div>
                            <div className={styles.visitorCountWrapper}>
                                <div className={styles.eachVCBox}>
                                    <FaFemale size={24} color="#00000080" />
                                    <div className={styles.counterBadge}>
                                        {bookingDetails.femaleQuant}
                                    </div>
                                </div>
                                <div className={styles.eachVCBox}>
                                    <FaMale size={24} color="#00000080" />
                                    <div className={styles.counterBadge}>
                                        {bookingDetails.maleQuant}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.timeLapsedWrapper}>
                            <div className={styles.timeLapsedHeader}>
                                Client Visited The Store
                            </div>
                            <div className={styles.timeLapsedBody}>
                                <div className={styles.eachTLUnit}>
                                    <div className={styles.tlUnitValue}>{timeLapsed[0].days}</div>
                                    <div className={styles.tlUnitCaption}>Days</div>
                                </div>
                                <div className={styles.eachTLUnit}>
                                    <div className={styles.tlUnitValue}>{timeLapsed[0].hours}</div>
                                    <div className={styles.tlUnitCaption}>Hours</div>
                                </div>
                                <div className={styles.eachTLUnit}>
                                    <div className={styles.tlUnitValue}>{timeLapsed[0].minutes}</div>
                                    <div className={styles.tlUnitCaption}>Minutes</div>
                                </div>
                                <div className={styles.eachTLUnit}>
                                    <div className={styles.tlUnitValue}>{timeLapsed[0].seconds}</div>
                                    <div className={styles.tlUnitCaption}>Seconds</div>
                                </div>
                            </div>
                            {/* <Clock width="100px" height="100px" interval={100} borderWidth={8} fillSmoothness={0.1} /> */}
                        </div>
                    </div>
                    <div className={styles.actionBtns}>
                        <button className={activeTab === "Services" ? styles.activeBtn : styles.defaultBtn} onClick={() => setActiveTab('Services')}>Services</button>
                        <button className={activeTab === "Payment" ? styles.activeBtn : styles.defaultBtn} onClick={() => setActiveTab('Payment')}>Payment Details</button>
                        <button className={activeTab === "Feedback" ? styles.activeBtn : styles.defaultBtn} onClick={() => setActiveTab('Feedback')}>Feedback</button>
                    </div>
                </div>
                {!isLoading &&
                    <div className={styles.mainBody}>
                        {activeTab === "Services" && <ServicesListAtBD bookingDetails={bookingDetails} />}

                        {activeTab === "Payment" &&
                            <div className={styles.bottomTotalWrap}>
                                <div className={styles.bottomTotalContainer}>

                                    <div className={styles.modesWrapper}>
                                        <div className={styles.modeContainer}>
                                            <div className={styles.eachModeRow}>
                                                <div>
                                                    Collection Via Card
                                                </div>
                                                <div>
                                                    {bookingDetails?.collectionViaCard}
                                                </div>
                                            </div>
                                            <div className={styles.eachModeRow}>
                                                <div>
                                                    Collection Via Cash
                                                </div>
                                                <div>
                                                    {bookingDetails?.collectionViaCash}
                                                </div>
                                            </div>
                                            <div className={styles.eachModeRow}>
                                                <div>
                                                    Collection Via QR
                                                </div>
                                                <div>
                                                    {bookingDetails?.collectionViaQR}
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                    <div className={styles.grandTotalWrapper}>
                                        <div>
                                            Grand Total
                                        </div>
                                        <div className={styles.finalPriceTagsWrapper}>
                                            {/* <div className={styles.orgPriceTotal}>
                                                &#8377;{orgPriceTotal}
                                            </div> */}
                                            <div className={styles.disPriceTotal}>
                                                &#8377;{disPriceTotal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {activeTab === "Feedback" &&
                            <div className={styles.feedbackWrapper}>
                                NA
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default BookingDetails